import { Application } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'
import Sortable from '@stimulus-components/sortable'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application
application.register('sortable', Sortable)

export { application }
